import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardBody, CardTitle, CardText, Form, Button, Spinner } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { login, loginSelector } from '../../redux/auth';
import FormikField from '../../components/forms/formik/FormikField';
import PasswordToggle from '../../components/forms/formik/PasswordToggle';
import Logo from '../../assets/images/ist-logo.png';
import '../../assets/scss/pages/login.scss';

const loginSchema = Yup.object({
  username: Yup.string('Enter your email').required('Email is required'),
  password: Yup.string('Enter your password')
    .min(4, 'Password should be of minimum 4 characters length')
    .required('Password is required')
});

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { error, loading, data } = useSelector(loginSelector);

  const isAuth = !!data.access_token;
  useEffect(() => {
    if (isAuth) {
      navigate('/');
    }
  }, [isAuth]);

  const initialValues = {
    username: '',
    password: ''
  };

  const handleSubmit = (values) => {
    let bodyFormData = new FormData();
    bodyFormData.append('username', values.username);
    bodyFormData.append('password', values.password);
    dispatch(login(bodyFormData));
  };

  return (
    <div className="auth-wrapper auth-basic px-2">
      <div className="auth-inner my-2">
        <Card className="mb-0">
          <CardBody>
            <div className="brand-logo">
              <img src={Logo} alt="logo" width="160" />
            </div>
            <CardTitle tag="h4" className="mb-1">
              Welcome To Nūn TTS Portal! 👋
            </CardTitle>
            <CardText className="mb-2">Please sign-in to your account</CardText>
            {error && (
              <div className="alert alert-danger alert-dismissible fade show" role="alert">
                <div className="alert-body">
                  <strong>Oops!</strong> {error}
                </div>
              </div>
            )}
            <Formik
              initialValues={initialValues}
              validationSchema={loginSchema}
              onSubmit={handleSubmit}>
              {({ handleSubmit }) => (
                <Form className="auth-login-form mt-2" onSubmit={handleSubmit}>
                  <FormikField name="username" label="Email" placeholder="Email" autoFocus />
                  <PasswordToggle className="input-group-merge" name="password" label="Password" />
                  <Button type="submit" color="primary" className="mt-2" disabled={loading} block>
                    Sign in {loading && <Spinner size="sm" className="mx-1" />}
                  </Button>
                </Form>
              )}
            </Formik>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default Login;
